export default {
  shoppingCartId: state => state.shoppingCartId,
  shoppingCart: state => state.shoppingCart,
  latestOrderId: state => state.order.latestOrderId,
  token: state => state.customer.token,
  customerId: state => state.customer.customerId
};